(function () {
    "use strict";

    // @ngInject
    function UploadClientsControllerCtor($scope, $injector, $modalInstance, AnalyticsService, UsersManager, PhotosUploadManager, PendingTasksManager, startFromStep) {
        this.constructor.$super.call(this, $scope, $injector);
        this._objectType = 'UploadClientsController';

        this.modalInstance = $modalInstance;
        this.AnalyticsService = AnalyticsService;
        this.PhotosUploadManager = PhotosUploadManager;
        this.PendingTasksManager = PendingTasksManager;
        this.startFromStep = startFromStep;

        this.user = UsersManager.getCurrUser();
        this._init();
    }

    Controllers.UploadClientsController = Class(Controllers.BaseController, {
        constructor: UploadClientsControllerCtor,

        _init: function _init() {
            this.analyticsFlow = 'upload_and_google_sync';

            if(this.startFromStep === 'upload') {
                this.analyticsFlow = 'upload';
                this.csvDialogActive = true;
            }

            this.AnalyticsService.trackPageView(this, 'UploadClientsModal', { flow: this.analyticsFlow});
        },

        csvUploadOptionChosen: function csvUploadOptionChosen() {
            this.csvDialogActive = true;
        },

        onAddClient: function onAddClient() {
            this.dismissModal('addClient');
        },

        onGoogleSync: function onGoogleSync() {
            this._analyticsGoogleSync();
            this.dismissModal('syncGoogleContact');
        },

        /* Upload File */
        _isEmptyFilesCollection: function _isEmptyFilesCollection($files) {
            return ($files && $files.length === 0 || !$files);
        },

        _isInvalidFile: function _isInvalidFile($invalidFiles) {
            switch ($invalidFiles[0].$error) {
                case "maxSize":
                    console.error('file must be under 2MB');
                    break;
                case "pattern":
                    console.error('file must be .csv or .xml');
                    break;
            }
        },

        onFileUploadSelected: function onFileUploadSelected($files, $invalidFiles) {
            this.fileUploadError = false;
            this.serverError = null;
            this.importAlreadyInProgress = false;

            if ($invalidFiles.length) {
                this._isInvalidFile($invalidFiles);
                return;
            }

            if (this._isEmptyFilesCollection($files)) {
                return;
            }

            var model = {
                instance: this.user.company,
                type: 'company_file',
                dontUpdateServer: true
            };

            this.PhotosUploadManager.getUpdatedModelData(model);
            var fileUploadPromise = this.PhotosUploadManager.uploadPhoto([$files[0]], model, this);

            fileUploadPromise.then(function uploadToS3Success() {
                var csvFile = $files[0];
                if(csvFile.s3Response && csvFile.s3Response.url) {
                    this._uploadFileToServer(csvFile.s3Response.url);
                } else {
                    this.fileUploadError = true;
                }
            }.bind(this)
            ).catch(function uploadToS3Fail() {
                this.fileUploadError = true;
            }.bind(this));

        },

        _uploadFileToServer: function _uploadFileToServer(csvFileUrl) {
            this.importAlreadyInProgress = false;
            var taskData = {
                s3_url: csvFileUrl
            };

            var pendingTaskPromise = this.PendingTasksManager.createPendingTask(this.PendingTasksManager.pendingTasksTypes.contactsCsvImport, taskData);

            pendingTaskPromise.then(
                function success() {
                    this.csvDialogActive = false;
                    this.csvProcessInProgress = true;
                }.bind(this))
                .catch(function fail(res) {
                    if (res && res.data && res.data.error_type && res.data.error_type === 'HBConflictError') {
                        this.importAlreadyInProgress = true;
                    } else {
                        if (angular.isString(res)) { // assuming we got an error from the server
                            this.serverError = res;
                        }
                        this.fileUploadError = true;
                    }
                }.bind(this));

        },

        /* Analytics */
        _analyticsGoogleSync: function _analyticsGoogleSync() {
            if (this.user.isGoogleIntegrationActive('contacts')) {
                this.AnalyticsService.trackClick(this, 'open google contacts',
                    {
                        source: "upload_clients_modal",
                        type: "contacts",
                        app_path: "second_level_nav",
                        event: "open google contacts",
                        eventType: "click"
                    });
            } else {
                this.AnalyticsService.trackClick(this, 'add gmail integration',
                    {
                        source: "upload_clients_modal",
                        type: "contacts",
                        app_path: "second_level_nav",
                        event: "add gmail integration",
                        eventType: "click"
                    });
            }
        },

        closeModal: function closeModal() {
            this.modalInstance.close();
        },

        dismissModal: function dismissModal(reason) {
            this.modalInstance.dismiss(reason);
        },
    });
}());
